var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useFieldArray, useForm } from 'react-hook-form';
import format from 'string-format';
import Stack from '@mui/material/Stack';
import { OGPanel } from '@opengear/panel';
import Divider from '@mui/material/Divider';
import DialogContentText from '@mui/material/DialogContentText';
import Box from '@mui/material/Box';
import { OGButton } from '@opengear/buttons';
import DialogContent from '@mui/material/DialogContent';
import { useFormSync } from '@/hooks/use-form-sync';
import { CancelButton, FormContainer, FormActions, SubmitButton, DeleteButton } from '@/components/layout/forms';
import { ConfirmPasswordField, DescriptionField, EnableRemoteOnlyPasswordField, EnableUserField, GroupsSection, PasswordField, PermissionsSection, SshAuthKeyDescriptionField, SshAuthKeyField, SshAuthKeySection, UsernameField, } from './user-form-controls';
import { USERS_ROUTE } from '@/constants/routes';
import { PasswordConfirmationModal, SshAuthKeyModal } from './modals';
import { useOpen } from '@/hooks/open';
import { transformUserFormData, transformUserApiData } from './transformers';
import { useUser, useUsers } from '@/api/users';
/** * Constants ** */
var SSH_AUTH_KEY_MODAL_TITLE_ID = 'ssh-auth-key-modal-title-id';
// useForm deep partials the generic type that you pass the hook.
// Defining the defaultValues as a variable ensures required fields exists
export var defaultUserFormValues = {
    enabled: false,
    username: '',
    description: '',
    password: '',
    confirmPassword: '',
    remoteOnlyPassword: false,
    groupNames: [],
    sshAuthKeys: [],
};
export function SshAuthKeyModalForm(_a) {
    var defaultValues = _a.defaultValues, permissions = _a.permissions, onCancel = _a.onCancel, onDelete = _a.onDelete, onSubmit = _a.onSubmit;
    var t = useTranslation().t;
    var sourceValues = defaultValues !== null && defaultValues !== void 0 ? defaultValues : { description: '', value: '' };
    var methods = useForm({ mode: 'onTouched', defaultValues: sourceValues });
    var mode = defaultValues ? 'update' : 'create';
    return (_jsx(FormContainer, __assign({ ariaLabelledBy: SSH_AUTH_KEY_MODAL_TITLE_ID, mode: mode, methods: methods, permissions: permissions, onSubmit: onSubmit }, { children: _jsxs(DialogContent, __assign({ sx: { marginTop: -2 }, tabIndex: -1 }, { children: [_jsx(SshAuthKeyDescriptionField, {}), _jsx(SshAuthKeyField, {}), _jsx(Divider, {}), _jsxs(FormActions, { children: [mode === 'update' && !permissions.isSecondary && !!onDelete && (_jsxs(_Fragment, { children: [_jsx(DeleteButton, { onClick: onDelete }), _jsx(Box, { flexGrow: 1 })] })), _jsx(OGButton, __assign({ variant: "borderless", onClick: onCancel }, { children: t('global.buttons.cancel') })), _jsx(SubmitButton, { children: t("components.user.form.fields.ssh_auth_key.table.modal.".concat(mode)) })] })] })) })));
}
export function UserForm(_a) {
    var _this = this;
    var userToEdit = _a.userToEdit, currentUser = _a.currentUser, groups = _a.groups, authMode = _a.authMode, passwordPolicy = _a.passwordPolicy, permissions = _a.permissions, submitHandler = _a.submitHandler;
    var navigate = useNavigate();
    var t = useTranslation().t;
    var _b = useOpen(), open = _b.open, openPasswordModal = _b.handleOpen, closePasswordModal = _b.handleClose;
    var isFetchingUsers = useUsers().isFetching;
    var isFetchingUser = useUser((userToEdit === null || userToEdit === void 0 ? void 0 : userToEdit.id) || '').isFetching;
    var sourceValues = useMemo(function () { return (userToEdit ? transformUserApiData(userToEdit, groups) : defaultUserFormValues); }, [userToEdit, groups]);
    // Form state
    var methods = useForm({ mode: 'onTouched', defaultValues: sourceValues });
    // Alert the user of data changes
    useFormSync(methods.formState.defaultValues, sourceValues, methods.reset, t('components.user.form.reset_warning.header'), isFetchingUsers || isFetchingUser);
    // Submit handler to add new or edit user
    var onSubmit = useCallback(function (formData) { return __awaiter(_this, void 0, void 0, function () {
        var requestData, newOrUpdatedUser;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestData = transformUserFormData(formData, groups);
                    return [4 /*yield*/, submitHandler(requestData)
                        // If successful, reset form and navigate to groups page
                    ];
                case 1:
                    newOrUpdatedUser = _a.sent();
                    // If successful, reset form and navigate to groups page
                    if (newOrUpdatedUser) {
                        methods.reset();
                        navigate(USERS_ROUTE);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [groups, submitHandler, methods, navigate]);
    // Handler for submit click, either submits directly (remote auth) or shows the password confirmation modal (local auth)
    var onClick = useCallback(function () {
        if (authMode === 'local') {
            openPasswordModal();
        }
        else {
            methods.handleSubmit(onSubmit)();
        }
    }, [openPasswordModal, authMode, methods, onSubmit]);
    // Reset handler to restore form to default values
    var handleCancel = useCallback(function () {
        navigate(USERS_ROUTE);
    }, [navigate]);
    // Handler for adding groups
    var handleAddGroups = useCallback(function (names) {
        if (names.length > 0) {
            // Prevent duplicates when adding to roleNames list
            var groupNamesSet = new Set(__spreadArray(__spreadArray([], __read(methods.getValues('groupNames')), false), __read(names), false));
            methods.setValue('groupNames', __spreadArray([], __read(groupNamesSet), false), { shouldDirty: true });
        }
    }, [methods]);
    // Handler for removing groups
    var handleRemoveGroup = useCallback(function (name) {
        // Remove all matching group
        var filteredGroupNames = methods.getValues('groupNames').filter(function (groupName) { return groupName !== name; });
        methods.setValue('groupNames', filteredGroupNames, { shouldDirty: true });
    }, [methods]);
    var isRoot = sourceValues.username === 'root';
    var showRemoteOnly = authMode !== 'local' && !isRoot && permissions.hasEditPermission;
    var remoteOnlyPassword = methods.watch('remoteOnlyPassword');
    var _c = __read(useState(0), 2), editSshAuthKeyIndex = _c[0], setEditSshAuthKeyIndex = _c[1];
    var createSshAuthKeyOpen = useOpen();
    var updateSshAuthKeyOpen = useOpen();
    var _d = useFieldArray({
        name: 'sshAuthKeys',
        control: methods.control,
    }), appendSshAuthKey = _d.append, updateSshAuthKey = _d.update, removeSshAuthKey = _d.remove;
    var editSshAuthKey = methods.watch("sshAuthKeys.".concat(editSshAuthKeyIndex));
    var onCreateSshAuthKey = useCallback(function (formData) {
        appendSshAuthKey(formData);
        createSshAuthKeyOpen.handleClose();
    }, [appendSshAuthKey, createSshAuthKeyOpen]);
    var onUpdateSshAuthKey = useCallback(function (formData) {
        updateSshAuthKey(editSshAuthKeyIndex, formData);
        updateSshAuthKeyOpen.handleClose();
    }, [updateSshAuthKey, editSshAuthKeyIndex, updateSshAuthKeyOpen]);
    var onSshAuthKeyClick = useCallback(function (keyIndex) {
        setEditSshAuthKeyIndex(keyIndex);
        updateSshAuthKeyOpen.handleOpen();
    }, [updateSshAuthKeyOpen]);
    var onDeleteSshAuthKey = useCallback(function () {
        removeSshAuthKey(editSshAuthKeyIndex);
        updateSshAuthKeyOpen.handleClose();
    }, [removeSshAuthKey, editSshAuthKeyIndex, updateSshAuthKeyOpen]);
    return (_jsxs(_Fragment, { children: [_jsxs(OGPanel, __assign({ sx: { padding: 0 } }, { children: [_jsxs(PasswordConfirmationModal, __assign({ title: !userToEdit ? t('components.user.password_modal.create_title') : t('components.user.password_modal.update_title'), open: open, username: currentUser, onSuccess: methods.handleSubmit(onSubmit), handleClose: closePasswordModal }, { children: [!!userToEdit && (_jsx(DialogContentText, __assign({ sx: { marginBottom: 1 } }, { children: format(t('components.user.password_modal.update_prompt'), userToEdit.username) }))), _jsx(DialogContentText, { children: t('components.user.password_modal.password_prompt') })] })), _jsxs(FormContainer, __assign({ mode: !userToEdit ? 'create' : 'update', methods: methods, permissions: permissions, onSubmit: onClick }, { children: [_jsxs(Stack, __assign({ padding: 2 }, { children: [_jsx(EnableUserField, {}), _jsx(UsernameField, {}), _jsx(DescriptionField, {}), showRemoteOnly && _jsx(EnableRemoteOnlyPasswordField, {}), !remoteOnlyPassword && _jsx(PasswordField, { passwordPolicy: passwordPolicy }), !remoteOnlyPassword && _jsx(ConfirmPasswordField, {})] })), _jsx(Divider, {}), _jsx(SshAuthKeySection, { onOpenUpdateModal: onSshAuthKeyClick, onOpenAddModal: createSshAuthKeyOpen.handleOpen }), _jsx(Divider, {}), _jsx(GroupsSection, { editable: permissions.hasEditPermission, groups: groups !== null && groups !== void 0 ? groups : [], handleAddGroups: handleAddGroups, handleRemoveGroup: handleRemoveGroup }), _jsx(Divider, {}), _jsx(PermissionsSection, {}), _jsx(Stack, __assign({ padding: 2 }, { children: _jsxs(FormActions, { children: [_jsx(CancelButton, { onCancel: handleCancel }), _jsx(SubmitButton, {})] }) }))] }))] })), _jsx(SshAuthKeyModal, __assign({ useOpen: createSshAuthKeyOpen, title: t('components.user.form.fields.ssh_auth_key.table.modal.title.create'), titleId: SSH_AUTH_KEY_MODAL_TITLE_ID }, { children: _jsx(SshAuthKeyModalForm, { permissions: permissions, onSubmit: onCreateSshAuthKey, onCancel: createSshAuthKeyOpen.handleClose }) })), _jsx(SshAuthKeyModal, __assign({ useOpen: updateSshAuthKeyOpen, title: t('components.user.form.fields.ssh_auth_key.table.modal.title.update'), titleId: SSH_AUTH_KEY_MODAL_TITLE_ID }, { children: _jsx(SshAuthKeyModalForm, { defaultValues: editSshAuthKey, permissions: permissions, onSubmit: onUpdateSshAuthKey, onCancel: updateSshAuthKeyOpen.handleClose, onDelete: onDeleteSshAuthKey }) }))] }));
}
